import { render, staticRenderFns } from "./HolidaysChildrenReport.vue?vue&type=template&id=1acc2c5f&"
import script from "./HolidaysChildrenReport.vue?vue&type=script&lang=js&"
export * from "./HolidaysChildrenReport.vue?vue&type=script&lang=js&"
import style0 from "./HolidaysChildrenReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports